export const useRuntimeConfig = () => 
window?.__NUXT__?.["nuxt-nav-app"]?.config || window?.useNuxtApp?.("nuxt-nav-app").payload?.config